<template>
  <b-overlay :show="showOverlay" rounded="sm">
    <b-row>
      <b-col cols="12">
        <SearchFilter @handleSubmit="searchFilterSubmit" />
      </b-col>
      <b-col cols="12">
        <commonTable ref="tableCommon" @handleOverlay="setOverlay" />
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import commonTable from "../../../../table/vue-good-table/commonTableAttach.vue";
import SearchFilter from "../../../../filters/SearchFilter.vue";
import { BCol, BRow, BOverlay } from "bootstrap-vue";

export default {
  components: {
    commonTable,
    SearchFilter,
    BOverlay,
    BCol,
    BRow,
  },
  data() {
    return {
      showOverlay: false,
    };
  },
  methods: {
    // setActiveTabName(name) {
    //   this.activeTab = []
    //   this.activeTab.push(name)
    // },
    // getManageDetail(id) {
    //   // let routeData = this.$router.resolve({name: 'LawScreeningManage', query: { id:id } });
    //   // window.open(routeData.href, '_blank');
    // },
    // getManageGroup(id) {
    //   // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
    //   // window.open(routeData.href, '_blank');
    //   const routeData = this.$router.resolve({ name: 'ScreeningManage', query: { id } })
    //   window.open(routeData.href, '_blank')
    // },
    searchFilterSubmit(params) {
      //console.log('searchFilterSubmit', params, )

      //console.log('searchFilterSubmit', this.$refs)

      this.$refs.tableCommon.onSearchSubmit(params);
    },
    // onBtnAddClicked() {
    //   window.open(this.$router.resolve({ name: 'servicecentercomplaint' ,query: { parentComponent: 'screening'}  }).href, '_self');
    // }
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
